import React from "react";
import { Outlet } from "react-router-dom";

const Fuel = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Fuel;
